import { axios } from "lib";


const getHomeInfo = () => {
  return axios.get('/anonymous/organization/info');
};

export { getHomeInfo};
export type {};
